import { render } from "./productDetailSingleSubOption.vue?vue&type=template&id=fdd650c0"
import script from "./productDetailSingleSubOption.vue?vue&type=script&lang=js"
export * from "./productDetailSingleSubOption.vue?vue&type=script&lang=js"

import "./productDetailSingleSubOption.vue?vue&type=style&index=0&id=fdd650c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__